import type { RowSelection } from './table-types.ts';
import styles from './DataTable.module.css';

const toggled = (selected: ReadonlySet<string>, keys: readonly string[], checked: boolean) => {
  const next = new Set(selected);
  for (const key of keys) {
    if (checked) next.add(key);
    else next.delete(key);
  }
  return next;
};

export const SelectCell = <Row,>({
  row,
  rowKey,
  selection,
}: {
  row: Row;
  rowKey: (row: Row) => string;
  selection: RowSelection<Row>;
}) => {
  const key = rowKey(row);
  return (
    <td
      className={styles['select']}
      onClick={(event) => {
        event.stopPropagation();
      }}
      onKeyDown={(event) => {
        event.stopPropagation();
      }}
    >
      <input
        type="checkbox"
        className={styles['checkbox']}
        aria-label={selection.rowLabel(row)}
        checked={selection.selected.has(key)}
        onChange={(event) => {
          selection.onChange(toggled(selection.selected, [key], event.target.checked));
        }}
      />
    </td>
  );
};

export const SelectAllHeader = <Row,>({
  keys,
  selection,
}: {
  keys: readonly string[];
  selection: RowSelection<Row>;
}) => {
  const chosen = keys.filter((key) => selection.selected.has(key)).length;
  const all = keys.length > 0 && chosen === keys.length;
  return (
    <th scope="col" className={styles['select']}>
      <input
        type="checkbox"
        className={styles['checkbox']}
        aria-label={selection.allLabel}
        checked={all}
        ref={(element) => {
          if (element !== null) element.indeterminate = chosen > 0 && !all;
        }}
        onChange={(event) => {
          selection.onChange(toggled(selection.selected, keys, event.target.checked));
        }}
      />
    </th>
  );
};
